module.exports = __webpack_public_path__ + "static/img/jieshao5.b6b4bda8.png";